import { useConfigContext } from "@/app";
import SubLayout from "@/components/SubLayout";
import { ActivePageDetailType, useActivePageStore } from "@/stores/activePageStore";
import { useLayoutEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
export function ActivePage() {
  const {
    activeId
  } = useParams();
  const activePageDetailMap = useActivePageStore(state => state.activePageDetailMap);
  const getActivePageDetail = useActivePageStore(state => state.getActivePageDetail);
  const activePageDetail = useMemo(() => {
    return activeId ? activePageDetailMap.get(activeId) : {
      title: '',
      content: ''
    };
  }, [activePageDetailMap]);
  useLayoutEffect(() => {
    activeId && getActivePageDetail(activeId);
  }, []);
  return <SubLayout title={activePageDetail?.title} data-sentry-element="SubLayout" data-sentry-component="ActivePage" data-sentry-source-file="index.tsx">
    <div dangerouslySetInnerHTML={{
      __html: activePageDetail?.content || ''
    }} />
 </SubLayout>;
}